import { theme } from "themes/default/theme"

export const styles = {
  optionBox: {
    width: 32,
    height: 32,
    borderRadius: 1,
    border: "1px solid #E5E5E5",
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mr: 1,
    cursor: "pointer",
    userSelect: "none",
  },
  lastOptionBox: {
    border: "none",
  },
  optionBoxSelected: {
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
  },
}
